import { FC, ReactElement, Suspense, useEffect, useState } from 'react';
import { RouterProvider, createBrowserRouter } from 'react-router';

import { RootRoutes } from './constants/routes/root.routes';
import LoadingIndicator from '@components/LoadingIndicatorMaterial/LoadingIndicator';
import { ChunkErrorBoundary } from '@components/ErrorBoundary';

const Root: FC = (): ReactElement<any> | null => {
  const [router, setRouter] = useState<any | null>(null);

  useEffect(() => {
    // ensure createBrowserRouter isn't called until the <App /> renders,
    // and this component renders w/in <App />
    const router = createBrowserRouter(RootRoutes);
    setRouter(router);
  }, []);

  if (router !== null) {
    return (
      <ChunkErrorBoundary>
        <Suspense fallback={<LoadingIndicator isLoading />}>
          <RouterProvider router={router} />
        </Suspense>
      </ChunkErrorBoundary>
    );
  } else {
    return null;
  }
};

export default Root;
